// extracted by mini-css-extract-plugin
export default {"setting_icon":"GamePage_setting_icon__sK5r2","error_user":"GamePage_error_user__AmAvN","not_games":"GamePage_not_games__UyzDM"};